//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ActionButtons",
  components: {
    SimpleButton,
    InlinePrompt
  },
  props: {
    isDisabledButtons: {
      type: Boolean,
      default: false
    },
    allowPreview: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: {
        copy: false,
        preview: false
      },
      status: {
        copy: false,
        preview: false
      }
    };
  },
  methods: {
    handleClick(event) {
      if (event === "preview" && !this.allowPreview) return;
      this.loading[event] = true;
      this.$emit(event);
    },
    stopPreviewLoader(status) {
      this.status.preview = status;
      this.$nextTick(() => {
        this.loading.preview = false;
      });
    },
    stopCopyLoader(status) {
      this.status.copy = status;
      this.$nextTick(() => {
        this.loading.copy = false;
      });
    }
  }
});